const adminActionList = {
  updateAdmins: 'adminList/update',
  updateAdmin: 'admin/update',
  dashboardInfo: 'admin/dashboard',
};

export default adminActionList;
